// removed by extract-text-webpack-plugin
module.exports = {"Settings":"Settings--3r6SZ","SettingsTitle":"SettingsTitle--2yG7d","setting":"setting--43uKT","SettingCards":"SettingCards--UOCYu","SettingCard":"SettingCard--38Yxl"};